import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../environment/environment.service';
import { PlatformService } from '../platform/platform.service';
@Injectable({
  providedIn: 'root'
})
export class LogService {
  constructor(
    private httpClient: HttpClient,
    private platformService: PlatformService,
    private environmentService: EnvironmentService
  ) {}

  public log(error: any): void {
        console.error(error);
    }

  // TODO: Rename log() to error() and debug() to log()
  public info(message?: any, ...optionalParams: any[]): void {
    const {
      debug,
      production,
    } = this.environmentService.environment;

    if (debug && (!this.platformService.isBrowser || !production)) {
      console.log.call(this, ...arguments);
    }
  }
}